import { Card, CardActions, CardContent, Grid, Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../Common/_hooks/useAppSelector";
import CardButton from "../../Common/Buttons/CardButton";
import useCheckStoreFeatures from "../../Common/_hooks/Store/useCheckStoreFeatures";
import { Link } from "react-router";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StoreLogoWrapper = styled('div')({
  borderRadius: '50%',
  width: '64px',
  flexShrink: 0,
})

const StoreLogo = styled('img')({
  width: '100%',
  height: 'auto'
})

interface Props {
  slug: string
  name: string
  image: string
  description: string
}

export default function StoreListCard(props: Props) {
  const [t] = useTranslation('account-v2')
  const [tR] = useTranslation('routes')

  const { canCreateProduct, canAutopay } = useCheckStoreFeatures(props.slug)

  const userHasStore = useAppSelector(state => !!state.get('userData').get('stores').find(store => store.get('slug') === props.slug))

  return <Grid item xs={12} sm={6}>
    <Card elevation={4} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={3}>
            <StoreLogoWrapper>
              <StoreLogo
                src={props.image}
                alt={t('Logo of {{store}}', { store: props.name })}
              />
            </StoreLogoWrapper>
            <Stack spacing={0.5}>
              <Typography variant="h3">{props.name}</Typography>
              <Typography variant="body2">{props.description}</Typography>
              { props.slug === 'etsy' ? <Typography variant="caption">{t('The term \'Etsy\' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.')}</Typography> : null}
            </Stack>
          </Stack>

          <Stack spacing={1}>
            <Typography variant="subtitle1">{t('With this integration, you can:')}</Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              { canCreateProduct ? <CheckCircleIcon fontSize="small" color="success"/> : <CancelIcon fontSize="small" color="error"/> }
              <Typography variant="caption" color={canCreateProduct ? 'success.main' : 'error.main'}>{t('Publish products')}</Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              {canAutopay ? <CheckCircleIcon fontSize="small" color="success"/> : <CancelIcon fontSize="small" color="error"/>}
              <Typography variant="caption" color={canAutopay ? 'success.main' : 'error.main'}>{t('Process orders automatically')}</Typography>
            </Stack>
          </Stack>


        </Stack>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        {userHasStore ? <CardButton
          color="success"
          component={Link}
          to={tR('/account/stores/connect/{{store}}', { store: props.slug })}
          startIcon={<CheckCircleIcon color="success" />}
        >{t('Setup')}</CardButton> : <CardButton
          color="primary"
          component={Link}
          to={tR('/account/stores/connect/{{store}}', { store: props.slug })}
        >{t('Connect')}</CardButton>}
      </CardActions>
    </Card>
  </Grid>
}
